import * as actionTypes from "../../action/actiontypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  loading: false,
  getPermissionItem: [],
  getRolesError: [],
  permissionSuccess: [],
  permissionErrors: [],
  fetchRolespermission: [],
  fetchRolesPermissionError: [],
  roleswithPermissionSuccess: [],
  roleswithPermissionError: [],
  deleteError: [],
  deleteSuccess: [],
};

const permissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_PERMISSION_REQUEST:
      return updateObject(state, {
        loading: true,
        permissionSuccess: "",
        permissionErrors: "",

        deleteSuccess: "",
        deleteError: "",
      });

    case actionTypes.GET_PERMISSION_SUCCESS:
      return updateObject(state, {
        loading: false,
        getPermissionItem: action.payload,
      });


    case actionTypes.CREATE_PERMISSION_REQUEST:
      return updateObject(state, {
        loading: true,
        permissionSuccess: "",
        permissionErrors: "",
      });

    case actionTypes.CREATE_PERMISSION_SUCCESS:
      return updateObject(state, {
        loading: false,
        permissionSuccess: action.payload,
      });

    case actionTypes.CREATE_PERMISSION_ERROR:
      return updateObject(state, {
        loading: false,
        permissionErrors: action.payload,
      });

    case actionTypes.UPDATE_PERMISSION_REQUEST:
      return updateObject(state, {
        loading: true,
        permissionSuccess: "",
        permissionErrors: "",
      });

    case actionTypes.UPDATE_PERMISSION_SUCCESS:
      return updateObject(state, {
        loading: false,
        permissionSuccess: action.payload,
      });

    case actionTypes.UPDATE_PERMISSION_ERROR:
      return updateObject(state, {
        loading: false,
        permissionErrors: action.payload,
      });

    case actionTypes.DELETE_PERMISSION_REQUEST:
      return updateObject(state, {
        loading: true,
        permissionSuccess: "",
        permissionErrors: "",
      });

    case actionTypes.DELETE_PERMISSION_SUCCESS:
      return updateObject(state, {
        loading: false,
        permissionSuccess: action.payload,
      });

    case actionTypes.DELETE_PERMISSION_ERROR:
      return updateObject(state, {
        loading: false,
        permissionErrors: action.payload,
      });
    case actionTypes.CREATE_ROLESWITHPERMISSION_REQUEST:
      return updateObject(state, {
        loading: true,
        roleswithPermissionSuccess: "",
        roleswithPermissionError: "",
      });

    case actionTypes.CREATE_ROLESWITHPERMISSION_SUCCESS:
      return updateObject(state, {
        loading: false,
        roleswithPermissionSuccess: action.payload,
      });

    case actionTypes.CREATE_ROLESWITHPERMISSION_ERROR:
      return updateObject(state, {
        loading: false,
        roleswithPermissionError: action.payload,
      });

    case actionTypes.FETCH_ROLESWITHPERMISSION_REQUEST:
      return updateObject(state, {
        loading: true,
        roleswithPermissionSuccess: "",
        roleswithPermissionError: "",
      });

    case actionTypes.FETCH_ROLESWITHPERMISSION_SUCCESS:
      return updateObject(state, {
        loading: false,
        roleswithPermissionSuccess: action.payload,
      });

    case actionTypes.FETCH_ROLESWITHPERMISSION_ERROR:
      return updateObject(state, {
        loading: false,
        roleswithPermissionError: action.payload,
      });

    case actionTypes.FETCH_ROLESWITHPERMISSIONBYID_REQUEST:
      return updateObject(state, {
        loading: true,
        fetchRolespermission: "",
        fetchRolesPermissionError: "",
      });

    case actionTypes.FETCH_ROLESWITHPERMISSIONBYID_SUCCESS:
      return updateObject(state, {
        loading: false,
        fetchRolespermission: action.payload,
      });

    case actionTypes.FETCH_ROLESWITHPERMISSIONBYID_ERROR:
      return updateObject(state, {
        loading: false,
        fetchRolesPermissionError: action.payload,
      });

    case actionTypes.UPDATE_ROLEWITHPERMISSION_REQUEST:
      return updateObject(state, {
        loading: true,
        roleswithPermissionSuccess: "",
        roleswithPermissionError: "",
      });

    case actionTypes.UPDATE_ROLEWITHPERMISSION_SUCCESS:
      return updateObject(state, {
        loading: false,
        roleswithPermissionSuccess: action.payload,
      });

    case actionTypes.UPDATE_ROLEWITHPERMISSION_ERROR:
      return updateObject(state, {
        loading: false,
        roleswithPermissionError: action.payload,
      });

    default:
      return state;
  }
};

export default permissionReducer;
